module.exports = __webpack_public_path__ + "assets/48f682699d8654742908bc0f7fb6d4c9.svg";